
export const getTodayHabits = (date, habits) => habits.filter(habit => habit.recurrence.indexOf(date.getDay()) > -1 && date.setHours(0,0,0,0) >= habit.created_at.setHours(0,0,0,0));
